import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchGroups } from "./similarWordsService";
import "./SimilarWords.css";

const SimilarWordsListPage = () => {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const load = async () => {
      console.log("[SimilarWordsListPage] Loading groups");
      setLoading(true);
      const res = await fetchGroups();
      if (res.status === 200 && res.data) {
        const list = res.data.data || (Array.isArray(res.data) ? res.data : []);
        console.log("[SimilarWordsListPage] Groups loaded:", list.length);
        setGroups(list);
      } else { console.error("[SimilarWordsListPage] Load failed:", res.status); setGroups([]); }
      setLoading(false);
    };
    load();
  }, []);

  return (
    <>
      <Navbar />
      <div className="sw-page">
        <h1 className="sw-title">🔤 Similar Words</h1>
        <p className="sw-subtitle">Master commonly confused words and homophones.</p>

        {loading ? (<p className="sw-loading">Loading...</p>) : groups.length === 0 ? (<p className="sw-empty">No word groups available yet.</p>) : (
          <div className="sw-grid">
            {groups.map((g) => (
              <div key={g.id} className="sw-card" onClick={() => navigate(`/study/similar-words/${g.id}`)}>
                <h3 className="sw-card-title">{g.title}</h3>
                <span className="sw-card-count">{g.wordCount || 0} words</span>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default SimilarWordsListPage;
